import React, { FC } from 'react';
import { PessoaPossivelmenteSemNome } from '../AvatarPessoa/AvatarPessoa';
import { SolicitacaoDetalhada } from 'model/solicitacao/SolicitacaoDetalhada';
import Lozenge from '@atlaskit/lozenge';

export interface RotulosPessoaSolicitacaProps {
  pessoa?: PessoaPossivelmenteSemNome
  solicitacao: SolicitacaoDetalhada
}

export const RotulosPessoaSolicitacao: FC<RotulosPessoaSolicitacaProps> = ({pessoa, solicitacao}) => {
  if (pessoa === undefined) {
    return <Lozenge>Sistema</Lozenge>
  }

  const tags: any = [];
  if (pessoa.idInstitucional === solicitacao.idSolicitante) {
    tags.push(<Lozenge key="solicitante">Solicitante</Lozenge>)
  }
  if (pessoa.idInstitucional === solicitacao.responsavelTecnico?.idInstitucional) {
    tags.push(<Lozenge key="responsavel-tecnico">Responsável técnico</Lozenge>)
  }

  return tags;
}